import { render, staticRenderFns } from "./salesReturnTemplate.vue?vue&type=template&id=9a00038e&scoped=true"
import script from "./salesReturnTemplate.vue?vue&type=script&lang=js"
export * from "./salesReturnTemplate.vue?vue&type=script&lang=js"
import style0 from "./salesReturnTemplate.vue?vue&type=style&index=0&id=9a00038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a00038e",
  null
  
)

export default component.exports